import React from 'react';

import Dash from '@dashboard/components/Dash';
import { CopyButton } from '@dashboard/components/OrderPage';

/** A ticket code: CouponCode's chip with a solid border, so tickets and coupons don't look alike. */
export default function TicketCode({ code, copy = true }) {
  if (!code) return <Dash />;
  return (
    <span className="group inline-flex items-center gap-1.5 align-middle">
      <span className="inline-flex items-center rounded-md border border-gray-300 dark:border-border px-2 py-0.5 font-mono text-xs font-medium tracking-wide text-gray-900 dark:text-foreground">
        {code}
      </span>
      {copy ? <CopyButton text={code} /> : null}
    </span>
  );
}
